import { CRS } from "./CRS";
import ihu from "url:../../../assets/cursors/HammerCursor.png";
import ihd from "url:../../../assets/cursors/HammerCursor-down.png";
import hsfx from "url:../../../assets/audio/hammer-sfx.mp3";
import { useState } from "react";

export function HAM () {
    const [image, setImage] = useState<string>(ihu);
    const aud = new Audio(hsfx);

    const md = (e : MouseEvent) => { 
        setImage(ihd);
        aud.play();
    }
    const mu = (e : MouseEvent) => { setImage(ihu); }

    return <CRS onMouseDown={md} onMouseUp={mu}>
        <img src={image} className='mcs-icon' />
    </CRS>
}